module.exports = __webpack_public_path__ + "img/rect.425b80b5.png";